<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>

    <Loader v-if="loading" />

    <div v-else-if="data.course.id" class="row">
      <div class="col-12 col-md-6 mb-5">
        <h2 class="d-block mb-3">{{ data.course.name }}</h2>
        <strong class="mb-3">Описание Курса:</strong>
        <p v-html="data.course.description" class=""></p>
        <p>
          <strong>Автор: </strong>
          <router-link
            :to="{ name: 'user_show', params: { id: data.user.id } }"
            >{{ data.user.name }}</router-link
          >
        </p>
      </div>
      <div class="col-12 col-md-6 mb-5 text-center d-flex flex-column align-items-center">
        <img :src="data.course.image" alt="" class="w-75 d-block mx-auto " />

        <router-link
          :to="{
            name: 'adminCourse_chapters',
            params: { course_id: data.course.id },
          }"
          class="btn btn-primary  w-75 mt-3"
          >Перейти к списку Глав</router-link
        >
      </div>
    </div>

    <!-- 
        <div v-else-if="data.course.id">
            <h2>{{data.course.name}}</h2>
            <img :src="data.course.image" alt="" class="w-50 d-block mx-auto">
            <h3>Автор: <router-link :to="{ name: 'user_show', params: { id: data.user.id } }">{{ data.user.name }}</router-link></h3>
            <router-link  :to="{ name: 'adminCourse_chapters', params: { course_id: data.course.id } }">Перейти к списку Глав</router-link>
            <p></p>
            <p></p>
            <p>Описание Курса:</p>
            <p v-html="data.course.description" class="bg-light shadow p-3 mb-5 bg-white rounded"></p>
            <hr>
        </div>
 -->
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "" },
      title: "Просмотр Курса",
      bcrumbs: [],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/courses/" + this.$route.params.id
        );
        this.data = response.data;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },
  components: {
    Loader,
    PageTitle,
    BreadCrumbs,
  },
};
</script>